import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, withKeys as _withKeys, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logo.svg'
import _imports_1 from '@/assets/logo-dark.svg'


const _withScopeId = n => (_pushScopeId("data-v-19b93446"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-wrap items-center justify-between mx-auto p-3" }
const _hoisted_2 = {
  key: 0,
  src: _imports_0,
  class: "h-8 mr-3",
  alt: "App Logo"
}
const _hoisted_3 = {
  key: 1,
  src: _imports_1,
  class: "h-8 mr-3",
  alt: "App Logo"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "hidden self-center text-2xl appFont whitespace-nowrap text-gray-700 dark:text-white" }, "WiZZL", -1))
const _hoisted_5 = { class: "absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none text-gray-300" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_HashtagIcon = _resolveComponent("HashtagIcon")!
  const _component_NavInput = _resolveComponent("NavInput")!
  const _component_SettingsIcon = _resolveComponent("SettingsIcon")!
  const _component_Button = _resolveComponent("Button")!
  const _component_CloseIcon = _resolveComponent("CloseIcon")!
  const _component_MagnifierIcon = _resolveComponent("MagnifierIcon")!

  return (_openBlock(), _createElementBlock("nav", {
    class: _normalizeClass(["fixed top-0 w-full shadow bg-white dark:bg-gray-800 z-[99]", {'hidden': !_ctx.showNavbar}])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_router_link, {
        to: "/",
        class: _normalizeClass(["flex items-center", {'hidden md:block': _ctx.search.open}])
      }, {
        default: _withCtx(() => [
          (_ctx.$theme.isLight())
            ? (_openBlock(), _createElementBlock("img", _hoisted_2))
            : (_openBlock(), _createElementBlock("img", _hoisted_3)),
          _hoisted_4
        ]),
        _: 1
      }, 8, ["class"]),
      _createElementVNode("div", {
        class: _normalizeClass([{'hidden': !_ctx.search.open}, "md:block relative items-center md:max-w-md md:w-full"])
      }, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_HashtagIcon)
        ]),
        _createVNode(_component_NavInput, {
          onKeyup: _withKeys(_ctx.searchAction, ["enter"]),
          placeholder: "Search",
          modelValue: _ctx.search.text,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search.text) = $event))
        }, null, 8, ["onKeyup", "modelValue"])
      ], 2),
      _createElementVNode("div", null, [
        _createVNode(_component_Button, {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push('/app/settings'))),
          class: _normalizeClass(["bg-white w-min inline-block", {'hidden md:inline-block': _ctx.search.open}]),
          grayTheme: true
        }, {
          default: _withCtx(() => [
            _createVNode(_component_SettingsIcon)
          ]),
          _: 1
        }, 8, ["class"]),
        _createVNode(_component_Button, {
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.search.open = false)),
          class: _normalizeClass(["bg-white w-min inline-block md:hidden", {'hidden': !_ctx.search.open}]),
          grayTheme: true
        }, {
          default: _withCtx(() => [
            _createVNode(_component_CloseIcon)
          ]),
          _: 1
        }, 8, ["class"]),
        _createVNode(_component_Button, {
          onClick: _ctx.searchAction,
          class: "ml-1 w-min",
          grayTheme: false
        }, {
          default: _withCtx(() => [
            _createVNode(_component_MagnifierIcon)
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ])
  ], 2))
}